<div id="{{id}}" class="page">
  <div class="header-group">
    <h3>{{title}}</h3>
    <div cls-action="close" class="btn btn-header-right ui-icon-close"></div>
  </div>
  <div class="fields inlineGroup">
    <field-search label-key="_SearchQuery" {(field)}="searchQuery"></field-search>
    <field-checkbox label-key="onlyWebService" {(field)}="onlyWebService"></field-checkbox>
  </div>

  <div class="inline-1btn">
    <a cls-action="clear" class="btn btn-cancel">{{msg "core-uda.ui.ResourceListCmp.clearFilter"}}</a>
  </div>
</div>
